<template>
  <div
    style=" box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23); background-color: white; border-radius: 20px; overflow:scroll; width: 100%;"
  >
    <div>
      <h3 style="text-align:center; padding: 20px 0px; margin: 0px;">ช่วงเช้า</h3>
      <table>
        <tr>
          <th></th>
          <th class="thfirst" colspan="3">CB2401</th>
        </tr>
        <tr>
          <td class="time">09.00 - 09.30</td>
          <td class="first" colspan="3">Register</td>
        </tr>
        <tr>
          <td class="time">09.30 - 09.50</td>
          <td>Introduction</td>
        </tr>
        <tr>
          <td class="time">09.50 - 11.00</td>
          <td class="first">2 Guest Speakers</td>
        </tr>
        <tr>
          <td class="time">11.00 - 12.00</td>
          <td>Lucky Draw</td>
        </tr>
        <tr>
          <td class="time">12.00 - 13.00</td>
          <td class="first">Launch</td>
        </tr>
        <tr>
          <td class="time">13.00 - 13.20</td>
          <td>Lucky Draw</td>
        </tr>
      </table>
    </div>
    <div>
      <h3 style="text-align:center; padding: 20px 0px; margin: 0px;">ช่วงบ่าย</h3>
      <table>
        <tr>
          <th></th>
          <th class="thfirst">CB2401</th>
          <th class="thsecond">CB2402</th>
          <th class="ththird">CB2405</th>
        </tr>
        <tr>
          <td class="time">13.20 - 13.40</td>
          <td class="first">Hatch: How KMUTT supports student entrepreneurship by วีรชา</td>
          <td class="second">How to make your web faster
            <br>by ธนนันท์
          </td>
          <td class="third">3.75 ปี กับสิ่งที่มหาลัยไม่ ได้ (ตั้งใจจะ) สอน
            <br>by Withee
          </td>
        </tr>
        <tr>
          <td class="time">13.40 - 13.50</td>
          <td colspan="3">เปลี่ยนห้อง</td>
        </tr>
        <tr>
          <td class="time">13.50 - 14.10</td>
          <td class="first">ผมไม่อยากทํางานประ จําเลยครับ
            <br>by Smith
          </td>
          <td class="second">My Life can Edit ชีวิตเรา ตัดต่อได้
            <br>by พีรกิตติ์
          </td>
          <td class="third">โลกของความขี้เกียจ
            <br>by Chirateep
          </td>
        </tr>
        <tr>
          <td class="time">14.10 - 14.20</td>
          <td colspan="3">เปลี่ยนห้อง</td>
        </tr>
        <tr>
          <td class="time">14.20 - 14.40</td>
          <td class="first">ชีวิตในมหาลัยท่ีไม่ได้หยุดอยู่ที่ห้องเรียน
            <br>by Chainarong&Nawapol
          </td>
          <td class="second">How an exchage program changed me (and my life)
            <br>by Tirapat
          </td>
          <td class="third">เมื่อชีววิทยาไม่ได้อยู่ แค่ในหนังสือเรียน Bioinformatics 101
            <br>by Jiramaetha
          </td>
        </tr>
        <tr>
          <td class="time">14.40 - 15.00</td>
          <td colspan="3">BREAK</td>
        </tr>
        <tr>
          <td class="time">15.00 - 15.20</td>
          <td class="first">What does a game designer do?
            <br>by Warat
          </td>
          <td class="second">ทำงาน 2 ปีกับ การย้ายงาน 4 ที่
            <br>by Sippakorn
          </td>
          <td class="third">วิถีชีวิตมนุษย์ล้อ
            <br>by Sattaya
          </td>
        </tr>
        <tr>
          <td class="time">15.20 - 15.30</td>
          <td colspan="3">เปลี่ยนห้อง</td>
        </tr>
        <tr>
          <td class="time">15.30 - 15.50</td>
          <td class="first">2 ปีที่ไม่ได้ทํางานประจํา
            <br>by Siwat
          </td>
          <td class="second">Dreams
            <br>by Napassorn
          </td>
          <td class="third">Customer experience in action
            <br>by Tamon
          </td>
        </tr>
        <tr>
          <td class="time">15.50 - 16.00</td>
          <td colspan="3">เปลี่ยนห้อง</td>
        </tr>
        <tr>
          <td class="time">16.00 - 16.20</td>
          <td class="first">ตะลุย Sillicon Valley กับ เด็กอายุ 17
            <br>by Phoomparin
          </td>
          <td class="second">Blockchain::the real evolution and the next revolution
            <br>by Rattapol
          </td>
          <td class="third">ศิลปะการสื่อสารและการ ทํางานร่วมกับผู้อื่น
            <br>by Sutham
          </td>
        </tr>
      </table>
    </div>

    <div id="location"/>
  </div>
</template>

<script>
export default {
  name: "timetable"
};
</script>

<style scoped>
.time {
  width: 200px;
}
@media screen and (max-width: 425px) {
  .time {
    width: 140px !important;
  }
  .first {
    width: 200px !important;
  }
  .second {
    width: 200px !important;
  }
  .third {
    width: 200px !important;
  }
  .thfirst {
    width: 200px !important;
  }
  .thsecond {
    width: 200px !important;
  }
  .ththird {
    width: 200px !important;
  }
}
.md-dialog {
  background-color: white;
  width: 100%;
  border-radius: 20px;
  max-height: 90% !important;
}
table {
  border-radius: 1em;
  width: 100%;
}

table,
th,
td {
  border: 0.75px solid rgb(181, 181, 181);
  border-collapse: collapse;
}

td {
  text-align: center;
}

td,
th {
  padding: 10px;
  text-align: center;
}

.first,
.second,
.third {
  color: white;
}

.first {
  background-color: rgb(220, 89, 147);
  width: auto;
}

.second {
  background-color: rgb(130, 86, 156);
  width: auto;
}

.third {
  background-color: rgb(62, 39, 98);
  width: auto;
}

.thfirst {
  color: rgb(220, 89, 147);
    width: auto;
}

.thsecond {
  color: rgb(130, 86, 156);
  width: auto;
}

.ththird {
  color: rgb(62, 39, 98);
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/timetable.vue